module.exports = {
  name: '出勤備註',
  schema: {
    type: 'Object',
    contents: {
      stafferRef: {
        type: 'ObjectId',
        name: '人員',
        reference: 'users',
        refKeys: ['name'],
      },
      date: {
        type: 'Date',
        name: '日期',
        format: 'YYYY/MM/DD',
      },
      comment: {
        type: 'String',
        name: '備註',
      },
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'stafferRef', width: 100 },
        { key: 'date', width: 200 },
        { key: 'comment', width: 200 },
      ],
    },
    editor: {
      groups: [
        {
          rows: [
            [{ key: 'stafferRef' }],
            [{ key: 'date' }],
            [{ key: 'comment' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/comments.js